
export const buildVideoGalleryProps = (block, state) => {
    
    const { props } = block;

    const buildProps = () => {

        let title = props.title ?? null;
        let text = props.text ?? null;
        let videos = props.videos ?? [];
        return {
            title,
            text,
            videos
        };
    };

    const resolvedProps = buildProps();

    return {
        id: block.id,
        type: block.type,
        props: resolvedProps,
    };
};

